let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jG1nH")).then(() => parcelRequire('9HF0e'));